// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/assets/img/sidebar-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.1 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.\\!absolute {
  position: absolute !important;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.\\!right-3 {
  right: 0.75rem !important;
}
.\\!right-3\\.5 {
  right: 0.875rem !important;
}
.\\!top-3 {
  top: 0.75rem !important;
}
.\\!top-3\\.5 {
  top: 0.875rem !important;
}
.-bottom-2 {
  bottom: -0.5rem;
}
.-right-10 {
  right: -2.5rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-3 {
  bottom: 0.75rem;
}
.bottom-\\[20\\%\\] {
  bottom: 20%;
}
.bottom-full {
  bottom: 100%;
}
.left-1\\/2 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.left-3\\.5 {
  left: 0.875rem;
}
.left-\\[35\\%\\] {
  left: 35%;
}
.left-\\[75\\%\\] {
  left: 75%;
}
.right-0 {
  right: 0px;
}
.right-3 {
  right: 0.75rem;
}
.start-0 {
  inset-inline-start: 0px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-2 {
  top: 0.5rem;
}
.top-2\\.5 {
  top: 0.625rem;
}
.top-3 {
  top: 0.75rem;
}
.top-8 {
  top: 2rem;
}
.top-\\[30\\%\\] {
  top: 30%;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-full {
  top: 100%;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[60\\] {
  z-index: 60;
}
.z-\\[99999\\] {
  z-index: 99999;
}
.col-span-2 {
  grid-column: span 2 / span 2;
}
.col-span-3 {
  grid-column: span 3 / span 3;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-0 {
  margin: 0px;
}
.m-1 {
  margin: 0.25rem;
}
.m-3 {
  margin: 0.75rem;
}
.m-auto {
  margin: auto;
}
.m-px {
  margin: 1px;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}
.-mt-3 {
  margin-top: -0.75rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-\\[1\\.2rem\\] {
  margin-left: 1.2rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-3\\.5 {
  margin-right: 0.875rem;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-\\[1px\\] {
  margin-top: 1px;
}
.box-border {
  box-sizing: border-box;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-16 {
  height: 4rem;
}
.h-24 {
  height: 6rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[100vh\\] {
  height: 100vh;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[19px\\] {
  height: 19px;
}
.h-\\[228px\\] {
  height: 228px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[274px\\] {
  height: 274px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[329px\\] {
  height: 329px;
}
.h-\\[386px\\] {
  height: 386px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[46px\\] {
  height: 46px;
}
.h-\\[474px\\] {
  height: 474px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[62px\\] {
  height: 62px;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[140px\\] {
  max-height: 140px;
}
.max-h-\\[268px\\] {
  max-height: 268px;
}
.max-h-\\[340px\\] {
  max-height: 340px;
}
.max-h-\\[380px\\] {
  max-height: 380px;
}
.max-h-\\[636px\\] {
  max-height: 636px;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-6 {
  min-height: 1.5rem;
}
.min-h-\\[285px\\] {
  min-height: 285px;
}
.min-h-\\[360px\\] {
  min-height: 360px;
}
.min-h-\\[574px\\] {
  min-height: 574px;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-1\\/3 {
  width: 33.333333%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-16 {
  width: 4rem;
}
.w-24 {
  width: 6rem;
}
.w-3 {
  width: 0.75rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-48 {
  width: 12rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-60 {
  width: 15rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[151px\\] {
  width: 151px;
}
.w-\\[180px\\] {
  width: 180px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[19px\\] {
  width: 19px;
}
.w-\\[220px\\] {
  width: 220px;
}
.w-\\[248px\\] {
  width: 248px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[260px\\] {
  width: 260px;
}
.w-\\[28px\\] {
  width: 28px;
}
.w-\\[376px\\] {
  width: 376px;
}
.w-\\[420px\\] {
  width: 420px;
}
.w-\\[560px\\] {
  width: 560px;
}
.w-\\[576px\\] {
  width: 576px;
}
.w-\\[72px\\] {
  width: 72px;
}
.w-\\[calc\\(100\\%-2rem\\)\\] {
  width: calc(100% - 2rem);
}
.w-fit {
  width: -moz-fit-content;
  width: fit-content;
}
.w-full {
  width: 100%;
}
.min-w-24 {
  min-width: 6rem;
}
.min-w-28 {
  min-width: 7rem;
}
.min-w-32 {
  min-width: 8rem;
}
.min-w-8 {
  min-width: 2rem;
}
.min-w-\\[100px\\] {
  min-width: 100px;
}
.min-w-\\[182px\\] {
  min-width: 182px;
}
.min-w-fit {
  min-width: -moz-fit-content;
  min-width: fit-content;
}
.min-w-full {
  min-width: 100%;
}
.min-w-min {
  min-width: min-content;
}
.max-w-80 {
  max-width: 20rem;
}
.max-w-\\[202px\\] {
  max-width: 202px;
}
.max-w-\\[70px\\] {
  max-width: 70px;
}
.max-w-full {
  max-width: 100%;
}
.flex-1 {
  flex: 1 1;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.origin-top-left {
  transform-origin: top left;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-4 {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-full {
  --tw-translate-y: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[135deg\\] {
  --tw-rotate: 135deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-move {
  cursor: move;
}
.cursor-no-drop {
  cursor: no-drop;
}
.cursor-pointer {
  cursor: pointer;
}
.resize-none {
  resize: none;
}
.resize {
  resize: both;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}
.grid-cols-\\[56px_1fr\\] {
  grid-template-columns: 56px 1fr;
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(120px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(120px,1fr));
}
.grid-cols-\\[repeat\\(auto-fit\\2c minmax\\(590px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fit,minmax(590px,1fr));
}
.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}
.grid-rows-4 {
  grid-template-rows: repeat(4, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-11 {
  gap: 2.75rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-20 {
  gap: 5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[1px\\] {
  gap: 1px;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.gap-x-1 {
  column-gap: 0.25rem;
}
.gap-x-10 {
  column-gap: 2.5rem;
}
.gap-x-2 {
  column-gap: 0.5rem;
}
.gap-y-0 {
  row-gap: 0px;
}
.gap-y-0\\.5 {
  row-gap: 0.125rem;
}
.gap-y-1 {
  row-gap: 0.25rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.375rem * var(--tw-space-x-reverse));
  margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.justify-self-start {
  justify-self: start;
}
.justify-self-end {
  justify-self: end;
}
.justify-self-center {
  justify-self: center;
}
.\\!overflow-auto {
  overflow: auto !important;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.\\!truncate {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.\\!text-nowrap {
  text-wrap: nowrap !important;
}
.text-nowrap {
  text-wrap: nowrap;
}
.\\!rounded-lg {
  border-radius: 0.5rem !important;
}
.\\!rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[32px\\] {
  border-radius: 32px;
}
.rounded-\\[4px\\] {
  border-radius: 4px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-l-\\[4px\\] {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-r-\\[4px\\] {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}
.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}
.rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}
.rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}
.\\!border {
  border-width: 1px !important;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.\\!border-b {
  border-bottom-width: 1px !important;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[2px\\] {
  border-bottom-width: 2px;
}
.border-b-\\[3px\\] {
  border-bottom-width: 3px;
}
.border-l {
  border-left-width: 1px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.\\!border-none {
  border-style: none !important;
}
.border-none {
  border-style: none;
}
.\\!border-\\[\\#9747FF\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(151 71 255 / var(--tw-border-opacity)) !important;
}
.\\!border-destructive-500 {
  border-color: rgba(240, 66, 66, 1) !important;
}
.border-amber-500 {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity));
}
.border-blue-500 {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
.border-blue-900 {
  --tw-border-opacity: 1;
  border-color: rgb(30 58 138 / var(--tw-border-opacity));
}
.border-brand-300\\/30 {
  border-color: rgba(96, 162, 227, 0.3);
}
.border-brand-300\\/50 {
  border-color: rgba(96, 162, 227, 0.5);
}
.border-brand-900 {
  border-color: rgba(15, 15, 116, 1);
}
.border-cyan-500 {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}
.border-destructive-500 {
  border-color: rgba(240, 66, 66, 1);
}
.border-emerald-500 {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
.border-fuchsia-500 {
  --tw-border-opacity: 1;
  border-color: rgb(217 70 239 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-green-500 {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
.border-indigo-500 {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}
.border-lime-500 {
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity));
}
.border-orange-500 {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}
.border-pink-500 {
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity));
}
.border-purple-500 {
  border-color: rgba(217, 191, 255, 1);
}
.border-red-500 {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
.border-red-500\\/20 {
  border-color: rgb(239 68 68 / 0.2);
}
.border-rose-500 {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity));
}
.border-sky-500 {
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity));
}
.border-success-500 {
  border-color: rgba(58, 179, 136, 1);
}
.border-teal-500 {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity));
}
.border-transparent {
  border-color: transparent;
}
.border-violet-500 {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity));
}
.border-yellow-500 {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity));
}
.border-x-transparent {
  border-left-color: transparent;
  border-right-color: transparent;
}
.\\!border-b-base-1000 {
  border-bottom-color: rgba(17, 17, 58, 1) !important;
}
.\\!border-b-base-400 {
  border-bottom-color: rgba(188, 200, 210, 1) !important;
}
.border-b-base-200 {
  border-bottom-color: rgba(230, 237, 243, 1);
}
.border-b-brand-300\\/30 {
  border-bottom-color: rgba(96, 162, 227, 0.3);
}
.border-b-red-500\\/20 {
  border-bottom-color: rgb(239 68 68 / 0.2);
}
.border-t-base-200 {
  border-top-color: rgba(230, 237, 243, 1);
}
.border-t-transparent {
  border-top-color: transparent;
}
.\\!bg-blue-300 {
  background-color: rgba(74, 162, 233, 0.6) !important;
}
.\\!bg-brand-100 {
  background-color: rgba(218, 235, 252, 1) !important;
}
.\\!bg-brand-300 {
  background-color: rgba(96, 162, 227, 1) !important;
}
.\\!bg-brand-900 {
  background-color: rgba(15, 15, 116, 1) !important;
}
.\\!bg-destructive-500 {
  background-color: rgba(240, 66, 66, 1) !important;
}
.\\!bg-inherit {
  background-color: inherit !important;
}
.\\!bg-neutral-100 {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity)) !important;
}
.\\!bg-transparent {
  background-color: transparent !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity));
}
.bg-amber-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 230 138 / var(--tw-bg-opacity));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity));
}
.bg-base-200 {
  background-color: rgba(230, 237, 243, 1);
}
.bg-black\\/70 {
  background-color: rgb(0 0 0 / 0.7);
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-blue-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-blue-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
.bg-brand-100 {
  background-color: rgba(218, 235, 252, 1);
}
.bg-brand-300 {
  background-color: rgba(96, 162, 227, 1);
}
.bg-brand-300\\/15 {
  background-color: rgba(96, 162, 227, 0.15);
}
.bg-brand-300\\/20 {
  background-color: rgba(96, 162, 227, 0.2);
}
.bg-brand-300\\/30 {
  background-color: rgba(96, 162, 227, 0.3);
}
.bg-brand-300\\/50 {
  background-color: rgba(96, 162, 227, 0.5);
}
.bg-brand-300\\/\\[0\\.08\\] {
  background-color: rgba(96, 162, 227, 0.08);
}
.bg-brand-500 {
  background-color: rgba(37, 99, 235, 1);
}
.bg-brand-900 {
  background-color: rgba(15, 15, 116, 1);
}
.bg-cyan-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity));
}
.bg-cyan-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(165 243 252 / var(--tw-bg-opacity));
}
.bg-cyan-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity));
}
.bg-declined-500 {
  background-color: rgba(182, 7, 45, 1);
}
.bg-declined-500\\/15 {
  background-color: rgba(182, 7, 45, 0.15);
}
.bg-destructive-500 {
  background-color: rgba(240, 66, 66, 1);
}
.bg-destructive-500\\/15 {
  background-color: rgba(240, 66, 66, 0.15);
}
.bg-destructive-500\\/30 {
  background-color: rgba(240, 66, 66, 0.3);
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity));
}
.bg-emerald-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(167 243 208 / var(--tw-bg-opacity));
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity));
}
.bg-fuchsia-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 232 255 / var(--tw-bg-opacity));
}
.bg-fuchsia-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 208 254 / var(--tw-bg-opacity));
}
.bg-fuchsia-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 70 239 / var(--tw-bg-opacity));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
.bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity));
}
.bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-indigo-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity));
}
.bg-indigo-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity));
}
.bg-indigo-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity));
}
.bg-lime-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 252 203 / var(--tw-bg-opacity));
}
.bg-lime-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 249 157 / var(--tw-bg-opacity));
}
.bg-lime-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(132 204 22 / var(--tw-bg-opacity));
}
.bg-neutral-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 245 245 / var(--tw-bg-opacity));
}
.bg-orange-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity));
}
.bg-orange-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 215 170 / var(--tw-bg-opacity));
}
.bg-orange-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity));
}
.bg-pink-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity));
}
.bg-pink-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(251 207 232 / var(--tw-bg-opacity));
}
.bg-pink-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity));
}
.bg-purple-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity));
}
.bg-purple-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity));
}
.bg-purple-500 {
  background-color: rgba(217, 191, 255, 1);
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity));
}
.bg-red-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 202 202 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-rejected-500 {
  background-color: rgba(252, 142, 118, 1);
}
.bg-rejected-500\\/15 {
  background-color: rgba(252, 142, 118, 0.15);
}
.bg-rose-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity));
}
.bg-rose-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 205 211 / var(--tw-bg-opacity));
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity));
}
.bg-sky-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(224 242 254 / var(--tw-bg-opacity));
}
.bg-sky-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity));
}
.bg-sky-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity));
}
.bg-success-500 {
  background-color: rgba(58, 179, 136, 1);
}
.bg-success-500\\/15 {
  background-color: rgba(58, 179, 136, 0.15);
}
.bg-teal-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity));
}
.bg-teal-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(153 246 228 / var(--tw-bg-opacity));
}
.bg-teal-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.bg-violet-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity));
}
.bg-violet-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(221 214 254 / var(--tw-bg-opacity));
}
.bg-violet-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-white\\/30 {
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/50 {
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/65 {
  background-color: rgb(255 255 255 / 0.65);
}
.bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
.bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity));
}
.bg-yellow-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-hero {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-cover {
  background-size: cover;
}
.bg-clip-text {
  background-clip: text;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.\\!p-0 {
  padding: 0px !important;
}
.\\!p-3 {
  padding: 0.75rem !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-16 {
  padding: 4rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-\\[0\\.45rem\\] {
  padding: 0.45rem;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5 {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[22px\\] {
  padding-left: 22px;
  padding-right: 22px;
}
.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-\\[0\\.55rem\\] {
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
}
.py-\\[11px\\] {
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}
.\\!pl-6 {
  padding-left: 1.5rem !important;
}
.\\!pr-5 {
  padding-right: 1.25rem !important;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-2\\.5 {
  padding-bottom: 0.625rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-11 {
  padding-left: 2.75rem;
}
.pl-16 {
  padding-left: 4rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-6 {
  padding-left: 1.5rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-14 {
  padding-right: 3.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-5 {
  padding-right: 1.25rem;
}
.pr-6 {
  padding-right: 1.5rem;
}
.pr-\\[38px\\] {
  padding-right: 38px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.pt-9 {
  padding-top: 2.25rem;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-sans {
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
.\\!text-\\[14px\\]\\/\\[20px\\] {
  font-size: 14px !important;
  line-height: 20px !important;
}
.\\!text-\\[16px\\]\\/\\[24px\\] {
  font-size: 16px !important;
  line-height: 24px !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[12px\\]\\/\\[16px\\] {
  font-size: 12px;
  line-height: 16px;
}
.text-\\[14px\\]\\/\\[150\\%\\] {
  font-size: 14px;
  line-height: 150%;
}
.text-\\[14px\\]\\/\\[16px\\] {
  font-size: 14px;
  line-height: 16px;
}
.text-\\[14px\\]\\/\\[18px\\] {
  font-size: 14px;
  line-height: 18px;
}
.text-\\[14px\\]\\/\\[20px\\] {
  font-size: 14px;
  line-height: 20px;
}
.text-\\[16px\\]\\/\\[21px\\] {
  font-size: 16px;
  line-height: 21px;
}
.text-\\[16px\\]\\/\\[24px\\] {
  font-size: 16px;
  line-height: 24px;
}
.text-\\[18px\\]\\/\\[24px\\] {
  font-size: 18px;
  line-height: 24px;
}
.text-\\[18px\\]\\/\\[26px\\] {
  font-size: 18px;
  line-height: 26px;
}
.text-\\[18px\\]\\/\\[28px\\] {
  font-size: 18px;
  line-height: 28px;
}
.text-\\[20px\\]\\/\\[24px\\] {
  font-size: 20px;
  line-height: 24px;
}
.text-\\[22px\\]\\/\\[28px\\] {
  font-size: 22px;
  line-height: 28px;
}
.text-\\[24px\\]\\/\\[32px\\] {
  font-size: 24px;
  line-height: 32px;
}
.text-\\[24px\\]\\/\\[36px\\] {
  font-size: 24px;
  line-height: 36px;
}
.text-\\[40px\\]\\/\\[100\\%\\] {
  font-size: 40px;
  line-height: 100%;
}
.text-\\[40px\\]\\/\\[48px\\] {
  font-size: 40px;
  line-height: 48px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\!font-medium {
  font-weight: 500 !important;
}
.\\!font-normal {
  font-weight: 400 !important;
}
.font-bold {
  font-weight: 700;
}
.font-light {
  font-weight: 300;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.normal-case {
  text-transform: none;
}
.ordinal {
  --tw-ordinal: ordinal;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[0\\] {
  line-height: 0;
}
.leading-none {
  line-height: 1;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.\\!text-base-1000 {
  color: rgba(17, 17, 58, 1) !important;
}
.\\!text-brand-1000 {
  color: rgba(11, 11, 70, 1) !important;
}
.text-\\[\\#6b7280\\] {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-amber-500 {
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity));
}
.text-base-1000 {
  color: rgba(17, 17, 58, 1);
}
.text-base-400 {
  color: rgba(188, 200, 210, 1);
}
.text-base-600 {
  color: rgba(122, 133, 143, 1);
}
.text-base-800 {
  color: rgba(71, 72, 83, 1);
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity));
}
.text-brand-300 {
  color: rgba(96, 162, 227, 1);
}
.text-brand-500 {
  color: rgba(37, 99, 235, 1);
}
.text-brand-900 {
  color: rgba(15, 15, 116, 1);
}
.text-cyan-500 {
  --tw-text-opacity: 1;
  color: rgb(6 182 212 / var(--tw-text-opacity));
}
.text-cyan-600 {
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity));
}
.text-declined-500 {
  color: rgba(182, 7, 45, 1);
}
.text-destructive-500 {
  color: rgba(240, 66, 66, 1);
}
.text-emerald-500 {
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity));
}
.text-fuchsia-500 {
  --tw-text-opacity: 1;
  color: rgb(217 70 239 / var(--tw-text-opacity));
}
.text-fuchsia-600 {
  --tw-text-opacity: 1;
  color: rgb(192 38 211 / var(--tw-text-opacity));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.text-indigo-500 {
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity));
}
.text-lime-500 {
  --tw-text-opacity: 1;
  color: rgb(132 204 22 / var(--tw-text-opacity));
}
.text-lime-600 {
  --tw-text-opacity: 1;
  color: rgb(101 163 13 / var(--tw-text-opacity));
}
.text-orange-500 {
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity));
}
.text-orange-600 {
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity));
}
.text-pink-500 {
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity));
}
.text-pink-600 {
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity));
}
.text-purple-500 {
  color: rgba(217, 191, 255, 1);
}
.text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-rejected-500 {
  color: rgba(252, 142, 118, 1);
}
.text-rose-500 {
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity));
}
.text-rose-600 {
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity));
}
.text-sky-500 {
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity));
}
.text-sky-600 {
  --tw-text-opacity: 1;
  color: rgb(2 132 199 / var(--tw-text-opacity));
}
.text-success-500 {
  color: rgba(58, 179, 136, 1);
}
.text-teal-500 {
  --tw-text-opacity: 1;
  color: rgb(20 184 166 / var(--tw-text-opacity));
}
.text-teal-600 {
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity));
}
.text-violet-500 {
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity));
}
.text-violet-600 {
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}
.text-yellow-400 {
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity));
}
.text-yellow-500 {
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity));
}
.line-through {
  text-decoration-line: line-through;
}
.placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-75 {
  opacity: 0.75;
}
.\\!shadow-\\[0_4px_20px_0_rgba\\(17\\2c 17\\2c 58\\2c 0\\.08\\)\\] {
  --tw-shadow: 0 4px 20px 0 rgba(17,17,58,0.08) !important;
  --tw-shadow-colored: 0 4px 20px 0 var(--tw-shadow-color) !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[-40px_40px_80px_-8px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.24\\)\\] {
  --tw-shadow: -40px 40px 80px -8px rgba(0,0,0,0.24);
  --tw-shadow-colored: -40px 40px 80px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-100 {
  transition-duration: 100ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.text-align-last-left {
  text-align-last: left;
}

.swiper.team {
    padding-bottom: 50px !important;
   
  }
  /* Swiper Navigation Styles */
  .swiper.team  .swiper-button-next,
  .swiper.team  .swiper-button-prev {
    color: #fff;
    font-size: 18px;
    /* Set the background color of your navigation arrows */
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
  
    justify-content: center;
    position: absolute;
    bottom: 1%;
    
    z-index: 10;
    cursor: pointer;
  }


  
  .swiper.team  .swiper-button-next {
    right: 0% !important;
  }

  
  .swiper.team  .swiper-pagination-bullet{
    border-radius: 0% !important;
    height: 3px !important;
    width: 2rem !important;
  }



  .swiper.contact {
    padding-bottom: 20px !important;
    position:unset !important
  }
  .swiper.contact  .swiper-button-next,
  .swiper.contact  .swiper-button-prev {
    color: #fff;
    font-size: 50px;
    /* Set the background color of your navigation arrows */
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
  
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: scaleY(1.2);
    z-index: 10;
    cursor: pointer;
  }

  .swiper.contact  .swiper-button-next {
    right: 2% !important;
  }

  .swiper.contact  .swiper-button-prev {
    left: 2% !important;
  }

  .swiper.contact  .swiper-pagination{
   
    bottom: 21px !important
  }



  .typed {
    font-size: 100%;
    text-align: left;
  
    vertical-align: text-bottom;
  }
  
  .typed::after {
    content: "❚";
    font-family: Arial, sans-serif;
    font-size: 100%;
    line-height: 20px;
    font-weight: 900;
    animation: blink 0.75s step-end infinite;
  }
  @keyframes blink {
    from,
    to {
      color: transparent;
    }
    50% {
      color: rgba(41, 38, 38, 0.579);
    }
  }
  


  .tab.reorder {
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  h1 {
    color: white;
    font-weight: 400;
  }
 
 
  select option {
    text-align: center;
  
    background-color: #fff;
    color: #333;
  }
 
 
  .placeholder\\:text-base-800::placeholder {
  color: rgba(71, 72, 83, 1);
}
 
 
  .placeholder\\:text-transparent::placeholder {
  color: transparent;
}
 
 
  .before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
 
 
  .before\\:-bottom-\\[11px\\]::before {
  content: var(--tw-content);
  bottom: -11px;
}
 
 
  .before\\:-bottom-\\[13px\\]::before {
  content: var(--tw-content);
  bottom: -13px;
}
 
 
  .before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}
 
 
  .before\\:h-\\[3px\\]::before {
  content: var(--tw-content);
  height: 3px;
}
 
 
  .before\\:w-\\[calc\\(100\\%\\+\\.5rem\\)\\]::before {
  content: var(--tw-content);
  width: calc(100% + .5rem);
}
 
 
  .autofill\\:pb-2:autofill {
  padding-bottom: 0.5rem;
}
 
 
  .autofill\\:pt-6:autofill {
  padding-top: 1.5rem;
}
 
 
  .hover\\:scale-125:hover {
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 
 
  .hover\\:rounded-lg:hover {
  border-radius: 0.5rem;
}
 
 
  .hover\\:border-blue-600:hover {
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity));
}
 
 
  .hover\\:border-destructive-500:hover {
  border-color: rgba(240, 66, 66, 1);
}
 
 
  .hover\\:border-success-500:hover {
  border-color: rgba(58, 179, 136, 1);
}
 
 
  .hover\\:\\!bg-base-200\\/50:hover {
  background-color: rgba(230, 237, 243, 0.5) !important;
}
 
 
  .hover\\:\\!bg-base-700:hover {
  background-color: rgba(17, 17, 58, 0.05) !important;
}
 
 
  .hover\\:\\!bg-blue-300:hover {
  background-color: rgba(74, 162, 233, 0.6) !important;
}
 
 
  .hover\\:\\!bg-brand-1000:hover {
  background-color: rgba(11, 11, 70, 1) !important;
}
 
 
  .hover\\:\\!bg-brand-200:hover {
  background-color: rgba(197, 217, 237, 1) !important;
}
 
 
  .hover\\:\\!bg-brand-400:hover {
  background-color: rgba(67, 141, 214, 1) !important;
}
 
 
  .hover\\:\\!bg-brand-900:hover {
  background-color: rgba(15, 15, 116, 1) !important;
}
 
 
  .hover\\:\\!bg-destructive-600:hover {
  background-color: rgba(205, 45, 45, 1) !important;
}
 
 
  .hover\\:\\!bg-transparent:hover {
  background-color: transparent !important;
}
 
 
  .hover\\:bg-\\[\\#EEF7FF\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(238 247 255 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-amber-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-base-700:hover {
  background-color: rgba(17, 17, 58, 0.05);
}
 
 
  .hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-brand-200:hover {
  background-color: rgba(197, 217, 237, 1);
}
 
 
  .hover\\:bg-cyan-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-destructive-500:hover {
  background-color: rgba(240, 66, 66, 1);
}
 
 
  .hover\\:bg-emerald-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-fuchsia-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(192 38 211 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-gray-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-green-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-indigo-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-lime-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-orange-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-pink-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-purple-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-red-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-rose-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-sky-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(2 132 199 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-success-500:hover {
  background-color: rgba(58, 179, 136, 1);
}
 
 
  .hover\\:bg-teal-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(13 148 136 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-violet-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity));
}
 
 
  .hover\\:bg-yellow-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity));
}
 
 
  .hover\\:text-amber-700:hover {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-blue-700:hover {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-cyan-700:hover {
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-emerald-700:hover {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-fuchsia-700:hover {
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-green-700:hover {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-indigo-700:hover {
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-lime-700:hover {
  --tw-text-opacity: 1;
  color: rgb(77 124 15 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-orange-700:hover {
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-pink-700:hover {
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-purple-700:hover {
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-red-700:hover {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-rose-700:hover {
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-sky-700:hover {
  --tw-text-opacity: 1;
  color: rgb(3 105 161 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-teal-700:hover {
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-violet-700:hover {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
 
 
  .hover\\:text-yellow-700:hover {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity));
}
 
 
  .hover\\:opacity-50:hover {
  opacity: 0.5;
}
 
 
  .focus\\:\\!rounded-lg:focus {
  border-radius: 0.5rem !important;
}
 
 
  .focus\\:border-amber-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(245 158 11 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-blue-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-cyan-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(6 182 212 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-destructive-500:focus {
  border-color: rgba(240, 66, 66, 1);
}
 
 
  .focus\\:border-emerald-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(16 185 129 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-fuchsia-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(217 70 239 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-green-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(34 197 94 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-lime-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(132 204 22 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-orange-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(249 115 22 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-pink-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(236 72 153 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-purple-500:focus {
  border-color: rgba(217, 191, 255, 1);
}
 
 
  .focus\\:border-red-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-rose-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(244 63 94 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-sky-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(14 165 233 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-success-500:focus {
  border-color: rgba(58, 179, 136, 1);
}
 
 
  .focus\\:border-teal-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(20 184 166 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-violet-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(139 92 246 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-yellow-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(234 179 8 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-x-transparent:focus {
  border-left-color: transparent;
  border-right-color: transparent;
}
 
 
  .focus\\:border-b-red-500:focus {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(239 68 68 / var(--tw-border-opacity));
}
 
 
  .focus\\:border-t-transparent:focus {
  border-top-color: transparent;
}
 
 
  .focus\\:\\!bg-base-200\\/50:focus {
  background-color: rgba(230, 237, 243, 0.5) !important;
}
 
 
  .focus\\:\\!bg-base-700:focus {
  background-color: rgba(17, 17, 58, 0.05) !important;
}
 
 
  .focus\\:\\!bg-blue-300:focus {
  background-color: rgba(74, 162, 233, 0.6) !important;
}
 
 
  .focus\\:\\!bg-brand-1000:focus {
  background-color: rgba(11, 11, 70, 1) !important;
}
 
 
  .focus\\:\\!bg-brand-200:focus {
  background-color: rgba(197, 217, 237, 1) !important;
}
 
 
  .focus\\:\\!bg-brand-400:focus {
  background-color: rgba(67, 141, 214, 1) !important;
}
 
 
  .focus\\:\\!bg-brand-900:focus {
  background-color: rgba(15, 15, 116, 1) !important;
}
 
 
  .focus\\:\\!bg-destructive-600:focus {
  background-color: rgba(205, 45, 45, 1) !important;
}
 
 
  .focus\\:\\!bg-transparent:focus {
  background-color: transparent !important;
}
 
 
  .focus\\:bg-\\[\\#EEF7FF\\]:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(238 247 255 / var(--tw-bg-opacity));
}
 
 
  .focus\\:bg-amber-100\\/50:focus {
  background-color: rgb(254 243 199 / 0.5);
}
 
 
  .focus\\:bg-blue-100\\/50:focus {
  background-color: rgb(219 234 254 / 0.5);
}
 
 
  .focus\\:bg-cyan-100\\/50:focus {
  background-color: rgb(207 250 254 / 0.5);
}
 
 
  .focus\\:bg-destructive-500:focus {
  background-color: rgba(240, 66, 66, 1);
}
 
 
  .focus\\:bg-emerald-100\\/50:focus {
  background-color: rgb(209 250 229 / 0.5);
}
 
 
  .focus\\:bg-fuchsia-100\\/50:focus {
  background-color: rgb(250 232 255 / 0.5);
}
 
 
  .focus\\:bg-green-100\\/50:focus {
  background-color: rgb(220 252 231 / 0.5);
}
 
 
  .focus\\:bg-indigo-100\\/50:focus {
  background-color: rgb(224 231 255 / 0.5);
}
 
 
  .focus\\:bg-lime-100\\/50:focus {
  background-color: rgb(236 252 203 / 0.5);
}
 
 
  .focus\\:bg-orange-100\\/50:focus {
  background-color: rgb(255 237 213 / 0.5);
}
 
 
  .focus\\:bg-pink-100\\/50:focus {
  background-color: rgb(252 231 243 / 0.5);
}
 
 
  .focus\\:bg-purple-100\\/50:focus {
  background-color: rgb(243 232 255 / 0.5);
}
 
 
  .focus\\:bg-red-100\\/50:focus {
  background-color: rgb(254 226 226 / 0.5);
}
 
 
  .focus\\:bg-rose-100\\/50:focus {
  background-color: rgb(255 228 230 / 0.5);
}
 
 
  .focus\\:bg-sky-100\\/50:focus {
  background-color: rgb(224 242 254 / 0.5);
}
 
 
  .focus\\:bg-success-500:focus {
  background-color: rgba(58, 179, 136, 1);
}
 
 
  .focus\\:bg-teal-100\\/50:focus {
  background-color: rgb(204 251 241 / 0.5);
}
 
 
  .focus\\:bg-violet-100\\/50:focus {
  background-color: rgb(237 233 254 / 0.5);
}
 
 
  .focus\\:bg-yellow-100\\/50:focus {
  background-color: rgb(254 249 195 / 0.5);
}
 
 
  .focus\\:pb-2:focus {
  padding-bottom: 0.5rem;
}
 
 
  .focus\\:pt-2:focus {
  padding-top: 0.5rem;
}
 
 
  .focus\\:pt-6:focus {
  padding-top: 1.5rem;
}
 
 
  .focus\\:text-white:focus {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
 
 
  .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
 
 
  .focus\\:ring:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
 
 
  .focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
 
 
  .focus\\:ring-1:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
 
 
  .focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
 
 
  .focus\\:ring-amber-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(245 158 11 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-amber-500\\/20:focus {
  --tw-ring-color: rgb(245 158 11 / 0.2);
}
 
 
  .focus\\:ring-amber-500\\/50:focus {
  --tw-ring-color: rgb(245 158 11 / 0.5);
}
 
 
  .focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-blue-500\\/20:focus {
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
 
 
  .focus\\:ring-blue-500\\/50:focus {
  --tw-ring-color: rgb(59 130 246 / 0.5);
}
 
 
  .focus\\:ring-cyan-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(6 182 212 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-cyan-500\\/20:focus {
  --tw-ring-color: rgb(6 182 212 / 0.2);
}
 
 
  .focus\\:ring-cyan-500\\/50:focus {
  --tw-ring-color: rgb(6 182 212 / 0.5);
}
 
 
  .focus\\:ring-emerald-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(16 185 129 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-emerald-500\\/20:focus {
  --tw-ring-color: rgb(16 185 129 / 0.2);
}
 
 
  .focus\\:ring-emerald-500\\/50:focus {
  --tw-ring-color: rgb(16 185 129 / 0.5);
}
 
 
  .focus\\:ring-fuchsia-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(217 70 239 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-fuchsia-500\\/20:focus {
  --tw-ring-color: rgb(217 70 239 / 0.2);
}
 
 
  .focus\\:ring-fuchsia-500\\/50:focus {
  --tw-ring-color: rgb(217 70 239 / 0.5);
}
 
 
  .focus\\:ring-green-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(34 197 94 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-green-500\\/20:focus {
  --tw-ring-color: rgb(34 197 94 / 0.2);
}
 
 
  .focus\\:ring-green-500\\/50:focus {
  --tw-ring-color: rgb(34 197 94 / 0.5);
}
 
 
  .focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-indigo-500\\/20:focus {
  --tw-ring-color: rgb(99 102 241 / 0.2);
}
 
 
  .focus\\:ring-indigo-500\\/50:focus {
  --tw-ring-color: rgb(99 102 241 / 0.5);
}
 
 
  .focus\\:ring-lime-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(132 204 22 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-lime-500\\/20:focus {
  --tw-ring-color: rgb(132 204 22 / 0.2);
}
 
 
  .focus\\:ring-lime-500\\/50:focus {
  --tw-ring-color: rgb(132 204 22 / 0.5);
}
 
 
  .focus\\:ring-orange-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(249 115 22 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-orange-500\\/20:focus {
  --tw-ring-color: rgb(249 115 22 / 0.2);
}
 
 
  .focus\\:ring-orange-500\\/50:focus {
  --tw-ring-color: rgb(249 115 22 / 0.5);
}
 
 
  .focus\\:ring-pink-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(236 72 153 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-pink-500\\/20:focus {
  --tw-ring-color: rgb(236 72 153 / 0.2);
}
 
 
  .focus\\:ring-pink-500\\/50:focus {
  --tw-ring-color: rgb(236 72 153 / 0.5);
}
 
 
  .focus\\:ring-purple-500:focus {
  --tw-ring-color: rgba(217, 191, 255, 1);
}
 
 
  .focus\\:ring-purple-500\\/20:focus {
  --tw-ring-color: rgba(217, 191, 255, 0.2);
}
 
 
  .focus\\:ring-purple-500\\/50:focus {
  --tw-ring-color: rgba(217, 191, 255, 0.5);
}
 
 
  .focus\\:ring-red-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-red-500\\/20:focus {
  --tw-ring-color: rgb(239 68 68 / 0.2);
}
 
 
  .focus\\:ring-red-500\\/50:focus {
  --tw-ring-color: rgb(239 68 68 / 0.5);
}
 
 
  .focus\\:ring-rose-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(244 63 94 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-rose-500\\/20:focus {
  --tw-ring-color: rgb(244 63 94 / 0.2);
}
 
 
  .focus\\:ring-rose-500\\/50:focus {
  --tw-ring-color: rgb(244 63 94 / 0.5);
}
 
 
  .focus\\:ring-sky-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(14 165 233 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-sky-500\\/20:focus {
  --tw-ring-color: rgb(14 165 233 / 0.2);
}
 
 
  .focus\\:ring-sky-500\\/50:focus {
  --tw-ring-color: rgb(14 165 233 / 0.5);
}
 
 
  .focus\\:ring-teal-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(20 184 166 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-teal-500\\/20:focus {
  --tw-ring-color: rgb(20 184 166 / 0.2);
}
 
 
  .focus\\:ring-teal-500\\/50:focus {
  --tw-ring-color: rgb(20 184 166 / 0.5);
}
 
 
  .focus\\:ring-violet-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(139 92 246 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-violet-500\\/20:focus {
  --tw-ring-color: rgb(139 92 246 / 0.2);
}
 
 
  .focus\\:ring-violet-500\\/50:focus {
  --tw-ring-color: rgb(139 92 246 / 0.5);
}
 
 
  .focus\\:ring-yellow-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(234 179 8 / var(--tw-ring-opacity));
}
 
 
  .focus\\:ring-yellow-500\\/20:focus {
  --tw-ring-color: rgb(234 179 8 / 0.2);
}
 
 
  .focus\\:ring-yellow-500\\/50:focus {
  --tw-ring-color: rgb(234 179 8 / 0.5);
}
 
 
  .focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
 
 
  .focus-visible\\:outline-none:focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
 
 
  .disabled\\:pointer-events-none:disabled {
  pointer-events: none;
}
 
 
  .disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
 
 
  .disabled\\:\\!bg-base-200\\/50:disabled {
  background-color: rgba(230, 237, 243, 0.5) !important;
}
 
 
  .disabled\\:\\!bg-base-400:disabled {
  background-color: rgba(188, 200, 210, 1) !important;
}
 
 
  .disabled\\:\\!bg-white:disabled {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity)) !important;
}
 
 
  .disabled\\:text-base-400:disabled {
  color: rgba(188, 200, 210, 1);
}
 
 
  .disabled\\:text-gray-300:disabled {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}
 
 
  .disabled\\:opacity-40:disabled {
  opacity: 0.4;
}
 
 
  .disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
 
 
  .group:hover .group-hover\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
 
 
  .group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
 
 
  .peer:focus ~ .peer-focus\\:-translate-y-3 {
  --tw-translate-y: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 
 
  .peer:focus ~ .peer-focus\\:-translate-y-5 {
  --tw-translate-y: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 
 
  .peer:focus ~ .peer-focus\\:scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 
 
  .peer:focus ~ .peer-focus\\:text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
 
 
  .peer:disabled ~ .peer-disabled\\:pointer-events-none {
  pointer-events: none;
}
 
 
  .peer:disabled ~ .peer-disabled\\:opacity-50 {
  opacity: 0.5;
}
 
 
  .peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:-translate-y-3 {
  --tw-translate-y: -0.75rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 
 
  .peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:-translate-y-5 {
  --tw-translate-y: -1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 
 
  .peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:scale-90 {
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
 
 
  .peer:not(:placeholder-shown) ~ .peer-\\[\\:not\\(\\:placeholder-shown\\)\\]\\:text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
 
 
  @media (min-width: 640px) {

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:w-\\[300px\\] {
    width: 300px;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:max-w-xl {
    max-width: 36rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}
 
 
  @media (min-width: 768px) {

  .md\\:block {
    display: block;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-\\[296px\\] {
    width: 296px;
  }

  .md\\:w-\\[576px\\] {
    width: 576px;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:min-w-32 {
    min-width: 8rem;
  }

  .md\\:min-w-\\[296px\\] {
    min-width: 296px;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:space-x-1 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-x-1\\.5 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(0.375rem * var(--tw-space-x-reverse));
    margin-left: calc(0.375rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .md\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .md\\:border-b {
    border-bottom-width: 1px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:pl-1 {
    padding-left: 0.25rem;
  }

  .md\\:pl-2 {
    padding-left: 0.5rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}
 
 
  @media (min-width: 1024px) {

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-10 {
    height: 2.5rem;
  }

  .lg\\:h-5 {
    height: 1.25rem;
  }

  .lg\\:h-\\[100vh\\] {
    height: 100vh;
  }

  .lg\\:w-10 {
    width: 2.5rem;
  }

  .lg\\:w-5 {
    width: 1.25rem;
  }

  .lg\\:w-72 {
    width: 18rem;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:gap-4 {
    gap: 1rem;
  }

  .lg\\:space-x-8 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(2rem * var(--tw-space-x-reverse));
    margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .lg\\:rounded-s-\\[3rem\\] {
    border-start-start-radius: 3rem;
    border-end-start-radius: 3rem;
  }

  .lg\\:rounded-tr-none {
    border-top-right-radius: 0px;
  }

  .lg\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .lg\\:border-r {
    border-right-width: 1px;
  }

  .lg\\:p-1 {
    padding: 0.25rem;
  }

  .lg\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:pb-0 {
    padding-bottom: 0px;
  }

  .lg\\:pr-1 {
    padding-right: 0.25rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .lg\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
 
 
  @media (min-width: 1280px) {

  .xl\\:h-9 {
    height: 2.25rem;
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:gap-10 {
    gap: 2.5rem;
  }

  .xl\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
 
 
  @media (min-width: 1536px) {

  .\\32xl\\:h-12 {
    height: 3rem;
  }

  .\\32xl\\:h-28 {
    height: 7rem;
  }

  .\\32xl\\:h-6 {
    height: 1.5rem;
  }

  .\\32xl\\:w-28 {
    width: 7rem;
  }

  .\\32xl\\:w-6 {
    width: 1.5rem;
  }

  .\\32xl\\:gap-20 {
    gap: 5rem;
  }

  .\\32xl\\:space-y-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(1rem * var(--tw-space-y-reverse));
  }

  .\\32xl\\:p-10 {
    padding: 2.5rem;
  }

  .\\32xl\\:p-2 {
    padding: 0.5rem;
  }

  .\\32xl\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .\\32xl\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .\\32xl\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .\\32xl\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .\\32xl\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
 
 
  @media (prefers-color-scheme: dark) {

  .dark\\:border-gray-700 {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity));
  }

  .dark\\:border-slate-600 {
    --tw-border-opacity: 1;
    border-color: rgb(71 85 105 / var(--tw-border-opacity));
  }

  .dark\\:bg-blue-500 {
    --tw-bg-opacity: 1;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity));
  }

  .dark\\:bg-slate-800 {
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity));
  }

  .dark\\:bg-slate-900 {
    --tw-bg-opacity: 1;
    background-color: rgb(15 23 42 / var(--tw-bg-opacity));
  }

  .dark\\:bg-white\\/10 {
    background-color: rgb(255 255 255 / 0.1);
  }

  .dark\\:bg-white\\/5 {
    background-color: rgb(255 255 255 / 0.05);
  }

  .dark\\:bg-opacity-80 {
    --tw-bg-opacity: 0.8;
  }

  .dark\\:text-amber-400 {
    --tw-text-opacity: 1;
    color: rgb(251 191 36 / var(--tw-text-opacity));
  }

  .dark\\:text-blue-400 {
    --tw-text-opacity: 1;
    color: rgb(96 165 250 / var(--tw-text-opacity));
  }

  .dark\\:text-cyan-400 {
    --tw-text-opacity: 1;
    color: rgb(34 211 238 / var(--tw-text-opacity));
  }

  .dark\\:text-emerald-400 {
    --tw-text-opacity: 1;
    color: rgb(52 211 153 / var(--tw-text-opacity));
  }

  .dark\\:text-fuchsia-400 {
    --tw-text-opacity: 1;
    color: rgb(232 121 249 / var(--tw-text-opacity));
  }

  .dark\\:text-gray-400 {
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity));
  }

  .dark\\:text-gray-700 {
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity));
  }

  .dark\\:text-green-400 {
    --tw-text-opacity: 1;
    color: rgb(74 222 128 / var(--tw-text-opacity));
  }

  .dark\\:text-indigo-400 {
    --tw-text-opacity: 1;
    color: rgb(129 140 248 / var(--tw-text-opacity));
  }

  .dark\\:text-lime-400 {
    --tw-text-opacity: 1;
    color: rgb(163 230 53 / var(--tw-text-opacity));
  }

  .dark\\:text-orange-400 {
    --tw-text-opacity: 1;
    color: rgb(251 146 60 / var(--tw-text-opacity));
  }

  .dark\\:text-pink-400 {
    --tw-text-opacity: 1;
    color: rgb(244 114 182 / var(--tw-text-opacity));
  }

  .dark\\:text-purple-400 {
    --tw-text-opacity: 1;
    color: rgb(192 132 252 / var(--tw-text-opacity));
  }

  .dark\\:text-red-400 {
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity));
  }

  .dark\\:text-rose-400 {
    --tw-text-opacity: 1;
    color: rgb(251 113 133 / var(--tw-text-opacity));
  }

  .dark\\:text-sky-400 {
    --tw-text-opacity: 1;
    color: rgb(56 189 248 / var(--tw-text-opacity));
  }

  .dark\\:text-teal-400 {
    --tw-text-opacity: 1;
    color: rgb(45 212 191 / var(--tw-text-opacity));
  }

  .dark\\:text-violet-400 {
    --tw-text-opacity: 1;
    color: rgb(167 139 250 / var(--tw-text-opacity));
  }

  .dark\\:text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
  }

  .dark\\:text-white\\/70 {
    color: rgb(255 255 255 / 0.7);
  }

  .dark\\:text-white\\/80 {
    color: rgb(255 255 255 / 0.8);
  }

  .dark\\:text-yellow-400 {
    --tw-text-opacity: 1;
    color: rgb(250 204 21 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:border-gray-700:hover {
    --tw-border-opacity: 1;
    border-color: rgb(55 65 81 / var(--tw-border-opacity));
  }

  .dark\\:hover\\:bg-gray-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }

  .dark\\:hover\\:bg-white\\/10:hover {
    background-color: rgb(255 255 255 / 0.1);
  }

  .dark\\:hover\\:text-amber-400:hover {
    --tw-text-opacity: 1;
    color: rgb(251 191 36 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-blue-400:hover {
    --tw-text-opacity: 1;
    color: rgb(96 165 250 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-cyan-400:hover {
    --tw-text-opacity: 1;
    color: rgb(34 211 238 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-emerald-400:hover {
    --tw-text-opacity: 1;
    color: rgb(52 211 153 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-fuchsia-400:hover {
    --tw-text-opacity: 1;
    color: rgb(232 121 249 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-green-400:hover {
    --tw-text-opacity: 1;
    color: rgb(74 222 128 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-indigo-400:hover {
    --tw-text-opacity: 1;
    color: rgb(129 140 248 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-lime-400:hover {
    --tw-text-opacity: 1;
    color: rgb(163 230 53 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-orange-400:hover {
    --tw-text-opacity: 1;
    color: rgb(251 146 60 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-pink-400:hover {
    --tw-text-opacity: 1;
    color: rgb(244 114 182 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-purple-400:hover {
    --tw-text-opacity: 1;
    color: rgb(192 132 252 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-red-400:hover {
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-rose-400:hover {
    --tw-text-opacity: 1;
    color: rgb(251 113 133 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-sky-400:hover {
    --tw-text-opacity: 1;
    color: rgb(56 189 248 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-teal-400:hover {
    --tw-text-opacity: 1;
    color: rgb(45 212 191 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-violet-400:hover {
    --tw-text-opacity: 1;
    color: rgb(167 139 250 / var(--tw-text-opacity));
  }

  .dark\\:hover\\:text-yellow-400:hover {
    --tw-text-opacity: 1;
    color: rgb(250 204 21 / var(--tw-text-opacity));
  }

  .dark\\:focus\\:bg-white\\/10:focus {
    background-color: rgb(255 255 255 / 0.1);
  }

  .dark\\:focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .dark\\:focus\\:ring-1:focus {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }

  .dark\\:focus\\:ring-gray-600:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(75 85 99 / var(--tw-ring-opacity));
  }
}
 
 
  .\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-full::-webkit-scrollbar-thumb {
  border-radius: 9999px;
}
 
 
  .\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-gray-300::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
 
 
  .\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-gray-100::-webkit-scrollbar-track {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
 
 
  .\\[\\&\\:\\:-webkit-scrollbar\\]\\:w-2::-webkit-scrollbar {
  width: 0.5rem;
}
 
 
  .\\[\\&\\:not\\(\\:placeholder-shown\\)\\]\\:pb-2:not(:placeholder-shown) {
  padding-bottom: 0.5rem;
}
 
 
  .\\[\\&\\:not\\(\\:placeholder-shown\\)\\]\\:pt-2:not(:placeholder-shown) {
  padding-top: 0.5rem;
}
 
 
  .\\[\\&\\:not\\(\\:placeholder-shown\\)\\]\\:pt-6:not(:placeholder-shown) {
  padding-top: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;IACI,+BAA+B;;EAEjC;EACA,6BAA6B;EAC7B;;IAEE,WAAW;IACX,eAAe;IACf,uDAAuD;IACvD,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;;IAEb,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;;IAEV,WAAW;IACX,eAAe;EACjB;;;;EAIA;IACE,oBAAoB;EACtB;;;EAGA;IACE,4BAA4B;IAC5B,sBAAsB;IACtB,sBAAsB;EACxB;;;;EAIA;IACE,+BAA+B;IAC/B;EACF;EACA;;IAEE,WAAW;IACX,eAAe;IACf,uDAAuD;IACvD,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;;IAEb,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE;EACF;;;;EAIA;IACE,eAAe;IACf,gBAAgB;;IAEhB,2BAA2B;EAC7B;;EAEA;IACE,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wCAAwC;EAC1C;EACA;IACE;;MAEE,kBAAkB;IACpB;IACA;MACE,8BAA8B;IAChC;EACF;;;;EAIA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;;EAGA;IACE,kBAAkB;;IAElB,sBAAsB;IACtB,WAAW;EACb;;;EA1HF;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,8BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,sBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,8BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,2GA0HG;EA1HH,yGA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,2GA0HG;EA1HH,yGA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,2GA0HG;EA1HH,yGA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,2GA0HG;EA1HH,yGA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,8BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,6BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,gBA0HG;EA1HH,gBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,0BA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,gBA0HG;EA1HH,gBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,oBA0HG;EA1HH;AA0HG;;;EA1HH;;EAAA;IAAA,iBA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;AAAA;;;EA1HH;;EAAA;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,uBA0HG;IA1HH,uDA0HG;IA1HH;EA0HG;;EA1HH;IAAA,uBA0HG;IA1HH,wDA0HG;IA1HH;EA0HG;;EA1HH;IAAA,uBA0HG;IA1HH,2DA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,kBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,mBA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,mBA0HG;IA1HH;EA0HG;AAAA;;;EA1HH;;EAAA;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,uBA0HG;IA1HH,oDA0HG;IA1HH;EA0HG;;EA1HH;IAAA,+BA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,iBA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,mBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,mBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,kBA0HG;IA1HH;EA0HG;AAAA;;;EA1HH;;EAAA;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,kBA0HG;IA1HH;EA0HG;AAAA;;;EA1HH;;EAAA;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,uBA0HG;IA1HH,4DA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,kBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,eA0HG;IA1HH;EA0HG;;EA1HH;IAAA,mBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,mBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,kBA0HG;IA1HH;EA0HG;AAAA;;;EA1HH;;EAAA;IAAA,sBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,sBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,kBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,kBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,kBA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,sBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,kBA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;;EA1HH;IAAA;EA0HG;;EA1HH;IAAA,8BA0HG;IA1HH;EA0HG;;EA1HH;IAAA,2GA0HG;IA1HH,yGA0HG;IA1HH;EA0HG;;EA1HH;IAAA,oBA0HG;IA1HH;EA0HG;AAAA;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA,kBA0HG;EA1HH;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG;;;EA1HH;EAAA;AA0HG","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n.swiper.team {\n    padding-bottom: 50px !important;\n   \n  }\n  /* Swiper Navigation Styles */\n  .swiper.team  .swiper-button-next,\n  .swiper.team  .swiper-button-prev {\n    color: #fff;\n    font-size: 18px;\n    /* Set the background color of your navigation arrows */\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    display: flex;\n  \n    justify-content: center;\n    position: absolute;\n    bottom: 1%;\n    \n    z-index: 10;\n    cursor: pointer;\n  }\n\n\n  \n  .swiper.team  .swiper-button-next {\n    right: 0% !important;\n  }\n\n  \n  .swiper.team  .swiper-pagination-bullet{\n    border-radius: 0% !important;\n    height: 3px !important;\n    width: 2rem !important;\n  }\n\n\n\n  .swiper.contact {\n    padding-bottom: 20px !important;\n    position:unset !important\n  }\n  .swiper.contact  .swiper-button-next,\n  .swiper.contact  .swiper-button-prev {\n    color: #fff;\n    font-size: 50px;\n    /* Set the background color of your navigation arrows */\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    display: flex;\n  \n    justify-content: center;\n    position: absolute;\n    top: 50%;\n    transform: scaleY(1.2);\n    z-index: 10;\n    cursor: pointer;\n  }\n\n  .swiper.contact  .swiper-button-next {\n    right: 2% !important;\n  }\n\n  .swiper.contact  .swiper-button-prev {\n    left: 2% !important;\n  }\n\n  .swiper.contact  .swiper-pagination{\n   \n    bottom: 21px !important\n  }\n\n\n\n  .typed {\n    font-size: 100%;\n    text-align: left;\n  \n    vertical-align: text-bottom;\n  }\n  \n  .typed::after {\n    content: \"❚\";\n    font-family: Arial, sans-serif;\n    font-size: 100%;\n    line-height: 20px;\n    font-weight: 900;\n    animation: blink 0.75s step-end infinite;\n  }\n  @keyframes blink {\n    from,\n    to {\n      color: transparent;\n    }\n    50% {\n      color: rgba(41, 38, 38, 0.579);\n    }\n  }\n  \n\n\n  .tab.reorder {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n  \n  h1 {\n    color: white;\n    font-weight: 400;\n  }\n \n \n  select option {\n    text-align: center;\n  \n    background-color: #fff;\n    color: #333;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
